import { navigate, routes } from '@redwoodjs/router'
import { useMutation } from '@redwoodjs/web'
import { toast } from '@redwoodjs/web/toast'
import { useAuth } from 'src/auth'
import { TWO_FACTOR_AUTH } from 'src/pages/TwoFactorPage/TwoFactorPage'

export const useLogout = () => {
  const { logOut, currentUser } = useAuth()
  const [twoFactorAuth] = useMutation(TWO_FACTOR_AUTH)

  const handleLogout = async () => {
    try {
      if (currentUser?.twoFactorEnabled) {
        await twoFactorAuth({
          variables: {
            input: {
              twoFactorVerified: false,
            },
          },
        })
      }
      await logOut()
      navigate(routes.login())
    } catch (error) {
      toast.error('Något gick fel')
    }
  }

  return handleLogout
}
